import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import icon from '../images/megaphone.png';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';


import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { signupUser } from '../redux/actions/userActions';


const Link = require('react-router-dom').Link;
const styles = (theme) => ({
    ...theme.spread
});

export class signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            confirmPassword: '',
            handle: '',
            errors: {}
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.UI.errors) {
            this.setState({ errors: nextProps.UI.errors });
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState(() => {
            return {
                loading: true
            }
        }, () => console.log(this.state))

        const newUserData = {
            email: this.state.email,
            password: this.state.password,
            confirmPassword: this.state.confirmPassword,
            handle: this.state.handle
        };
        this.props.signupUser(newUserData, this.props.history);
    }

    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        this.setState(() => {
            return {
                [name]: value
            }
        }, () => console.log(this.state))
    }
    render() {
        const { classes, UI: { loading } } = this.props;
        const { errors } = this.state;
        console.log(this.props)
        return (
            <Grid container className='form'>
                <Grid item sm />
                <Grid item sm>
                    <img className={classes.image} src={icon} alt='signup' Width='100px' />
                    <Typography className={classes.pageTitle} variant='h2' >
                        Signup
                    </Typography>
                    <form noValidate onSubmit={this.handleSubmit} >
                        <TextField id='email' name='email' type='email' label='Email' className={classes.TextField} value={this.state.email}
                            helperText={errors.email} error={errors.email ? true : false} onChange={this.handleChange} fullWidth
                        />
                        <TextField id='password' name='password' type='password' label='Password' className={classes.TextField} value={this.state.password}
                            helperText={errors.password} error={errors.password ? true : false} onChange={this.handleChange} fullWidth
                        />
                        <TextField id='confirmPassword' name='confirmPassword' type='confirmPassword' label='Confirm password' className={classes.TextField} value={this.state.confirmPassword}
                            helperText={errors.confirmPassword} error={errors.confirmPassword ? true : false} onChange={this.handleChange} fullWidth
                        />
                        <TextField id='handle' name='handle' type='handle' label='Handle' className={classes.TextField} value={this.state.handle}
                            helperText={errors.handle} error={errors.handle ? true : false} onChange={this.handleChange} fullWidth
                        />
                        {errors.error === 'auth/invalid-email' ? (
                            <Typography variant='body2' className={classes.customError}>
                                Invalid credentials!
                            </Typography>
                        ) : null}
                        <Button disabled={loading} type='submit' variant='contained' color='primary' className={classes.button}>signup {loading && (<CircularProgress size={30} className='signup-progress' />)}</Button>
                        <br />
                        <small>
                            already have an account? log in <Link to='/signup'>here</Link>
                        </small>
                    </form>
                </Grid>
                <Grid item sm />
            </Grid>
        )
    }
}

signup.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    UI: PropTypes.object.isRequired,
    signupUser: PropTypes.func.isRequired

}


const mapStateToProps = (state) => ({
    user: state.user,
    UI: state.UI
});

export default connect(mapStateToProps, { signupUser })(withStyles(styles)(signup));
